// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".merge-request-navigation-bar .nav{overflow-x:hidden;overflow-y:hidden}@media screen and (max-width:767.98px){.merge-request-navigation-bar .nav{overflow-x:scroll}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
